export default "__VITE_ASSET__48e81204__"